controllers.controller('WithdrawHistoryController', [
    '$scope', '$state', '$filter', '$ionicModal', '$ionicLoading', '$timeout', '$ionicPopup',
    'config', 'constants', 'Utils', 'API', 'UserService', 'LocaleService', 'WithdrawHistoryService', 'ServerTimeService',
    function ($scope, $state, $filter, $ionicModal, $ionicLoading, $timeout, $ionicPopup,
              config, Const, Utils, API, UserService, LocaleService, WithdrawHistoryService, ServerTimeService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.transactions = [];
        $scope.constants = Const;
        $scope.user = UserService.get();
        $scope.clientTimeZone = ServerTimeService.clientTimeZone >= 0 ? ('+' + ServerTimeService.clientTimeZone.toString())
            : ServerTimeService.clientTimeZone.toString();

        $scope.periods = [
            {id: 'day', label: LocaleService.translation.dateRange.day},
            {id: 'threedays', label: LocaleService.translation.dateRange.threedays},
            {id: 'week', label: LocaleService.translation.dateRange.week},
            {id: 'month', label: LocaleService.translation.dateRange.month},
            {id: 'threemonths', label: LocaleService.translation.dateRange.threemonths},
            {id: 'all', label: LocaleService.translation.dateRange.all}
        ];
        $scope.transactionTypes = [
            {id: 'pending', label: LocaleService.translation.pending},
            {id: 'approved', label: LocaleService.translation.approved},
            {id: 'Canceled', label: LocaleService.translation.canceled || 'Canceled'},
            {id: 'rejected', label: LocaleService.translation.rejected},
            {id: 'all', label: LocaleService.translation.all}
        ];
        $scope.tradingAccounts = $scope.user.tradingAccounts
            .filter(function (account) { return account.live })
            .map(function (account) {
                    return {
                        id: account.login.toString(),
                        label: '#' + account.login + ' LIVE',
                        currency: account.currency
                    }
                }
            )
            .concat({id: 'all', label: LocaleService.translation.all_accounts, currency: ''});

        $scope.filter = {
            period: _.find($scope.periods, {id: 'all'}),
            transactionType: _.find($scope.transactionTypes, {id: 'all'}),
            tradingAccount: _.find($scope.tradingAccounts, {id: 'all'})
        };
        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.navigate = function (state) {
            $state.go(state);
        };

        $scope.showFilter = function () {
            var myPopup = $ionicPopup.show({
                templateUrl: 'templates/transactionsFilter.html',
                title: '<span class="roboto">' + LocaleService.translation.filterBy + '</span>',
                scope: $scope,
                buttons: [
                    {text: LocaleService.translation.cancel},
                    {
                        text: LocaleService.translation.filter,
                        type: 'button-positive',
                        onTap: function (e) {
                            e.preventDefault();
                            filterTrades();
                            myPopup.close();
                        }
                    }
                ]
            });
        };

        $scope.cancelRequest = function(transaction) {
            $ionicPopup
                .confirm({
                    title: $scope.translation.withdrawRequest,
                    template: $scope.translation.cancelWithdrawal
                })
                .then(function (res) {
                    if (res) {
                        $scope.loadingMessage = '';
                        $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

                        WithdrawHistoryService
                            .cancelWithdrawalRequest(transaction.id)
                            .then(function () {
                                $ionicLoading.hide();
                                // $scope.paymentPopup && $scope.paymentPopup.close();
                                $scope.modal.textTitle = LocaleService.translation.messages.cancelRequest;
                                $scope.modal.isError = false;
                                $scope.modal.actionText = LocaleService.translation.continueTrading;
                                $scope.modal.textContent = LocaleService.translation.withdrawCancelSuccess;
                                $scope.modal.back = 'root.app.withdraw';
                                $scope.modal.state = true;
                            })
                            .catch(function (error) {
                                $ionicLoading.hide();
                                $scope.modal.textTitle = LocaleService.translation.messages.general_error;
                                // $scope.paymentPopup && $scope.paymentPopup.close();
                                $scope.modal.actionText = LocaleService.translation.tryAgain;
                                $scope.modal.isError = true;
                                $scope.modal.textContent = LocaleService.translation.messages[error.code] ||
                                    LocaleService.translation.withdrawCancelFailed;
                                $scope.modal.back = 'root.app.withdraw';
                                $scope.modal.state = true;
                            })
                    }
                });
        };

        //region Ionic events
        $scope.$on('$ionicView.beforeEnter', function () {
            if ($scope.user) {
                switch ($scope.user.registrationState) {
                    case Const.userState.initial:
                        return $state.go('signupPersonalProfile', {cache: false});
                    case Const.userState.personal:
                        return $state.go('signupQuestionnaire', {cache: false});
                }

                return UserService.kycCheck() || getTransactions();
            }

            return getTransactions();
        });

        $scope.$on('$ionicView.afterLeave', function () {
            $scope.transactions = [];
        });
        //endregion Ionic events

        //region Private Fns
        function getTransactions() {
            $scope.loadingMessage = LocaleService.translation.loading_transactions;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});
            return WithdrawHistoryService.getWithdrawalRequests()
                .then($ionicLoading.hide)
                .then(filterTrades);
        }

        function filterTrades() {
            $scope.transactions = [];
            if(!WithdrawHistoryService.collection) {
                return  $scope.transactions
            }
            $scope.transactions =  WithdrawHistoryService.collection.find()
                .filter(function (transaction) {
                    //filter by time period
                    if ($scope.filter.period.id === 'all') return transaction;
                    var timeRange = Utils.setTimeRange($scope.filter.period.id);
                    return transaction.requestDate >= timeRange.Start * 1000 && transaction.requestDate <= timeRange.End * 1000;
                })
                .filter(function (transaction) {
                    //filter by status type
                    if ($scope.filter.transactionType.id === 'all') {
                        return transaction;
                    } else if ($scope.filter.transactionType.id === 'Canceled') {
                        return transaction.status.toLowerCase().includes('cancelled');
                    } else {
                        return transaction.status === $scope.filter.transactionType.id;
                    }
                })
                .filter(function (transaction) {
                    //filter by account
                    if ($scope.filter.tradingAccount.id === 'all') return transaction;
                    return transaction.login.toString() === $scope.filter.tradingAccount.id;
                });
        }
        //endregion
    }]);
